import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  type: 'success' | 'warning' | 'danger' | 'info';
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  getIconClass(): string {
    switch (this.data.type) {
      case 'success':
        return 'fas fa-check-circle text-success';
      case 'warning':
        return 'fas fa-exclamation-triangle text-warning';
      case 'danger':
        return 'fas fa-exclamation-circle text-danger';
      case 'info':
      default:
        return 'fas fa-info-circle text-info';
    }
  }

  getConfirmButtonClass(): string {
    switch (this.data.type) {
      case 'success':
        return 'btn-success';
      case 'warning':
        return 'btn-warning';
      case 'danger':
        return 'btn-danger';
      case 'info':
      default:
        return 'btn-primary';
    }
  }
}
